import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-cream-50 relative overflow-hidden" data-id="element-94">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-95">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500 rounded-full blur-[120px] opacity-10" data-id="element-96"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-98">
          <h2 className="font-serif text-4xl md:text-5xl text-teal-900 mb-6" data-id="element-99">
            The Real Promise
          </h2>
          <p className="text-xl text-charcoal-800 mb-4" data-id="element-100">
            In 21 days, you won't feel lost anymore.
          </p>
          <p className="text-xl text-charcoal-800 mb-6 font-bold" data-id="element-101">
            You'll know:
          </p>
          <ul className="text-lg text-charcoal-800 text-left max-w-md mx-auto space-y-3 mb-8" data-id="element-102">
            <li className="flex items-start" data-id="element-103">
              <span className="text-gold-500 mr-3 mt-1" data-id="element-104">•</span>
              <span data-id="element-105">What to eat</span>
            </li>
            <li className="flex items-start" data-id="element-106">
              <span className="text-gold-500 mr-3 mt-1" data-id="element-107">•</span>
              <span data-id="element-108">How to move</span>
            </li>
            <li className="flex items-start" data-id="element-109">
              <span className="text-gold-500 mr-3 mt-1" data-id="element-110">•</span>
              <span data-id="element-111">What to do when life gets busy</span>
            </li>
            <li className="flex items-start" data-id="element-112">
              <span className="text-gold-500 mr-3 mt-1" data-id="element-113">•</span>
              <span data-id="element-114">How to stay consistent without starting over</span>
            </li>
          </ul>
          <p className="text-lg font-medium text-teal-800 italic" data-id="element-115">
            And that's how results finally become predictable again.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} id="pricing-card" className="bg-white p-8 md:p-12 rounded-2xl shadow-2xl border border-cream-200 text-center" data-id="element-116">
          <div className="mb-8" data-id="element-117">
            <span className="text-charcoal-600 text-lg uppercase tracking-widest font-medium" data-id="element-118">
              One-Time Payment
            </span>
            <div className="flex items-center justify-center mt-4 mb-2 gap-4" data-id="element-119">
              <span className="text-2xl text-charcoal-800/40 line-through font-serif" data-id="element-120">
                $19.99
              </span>
              <span className="text-6xl font-serif text-teal-900" data-id="element-121">$6.39</span>
              <span className="bg-gold-500 text-white text-sm font-semibold px-3 py-1 rounded-full self-start mt-2" data-id="element-122">
                68% OFF
              </span>
            </div>
            <p className="text-charcoal-500" data-id="element-123">Instant PDF Download</p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-124">
            <Button fullWidth className="text-xl py-6 group" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'AddToCart', {
                content_name: 'The Peri-Belly Protocol',
                content_type: 'product',
                value: 6.39,
                currency: 'USD'
              });
            }
            window.location.href = 'https://ecoviewdigital.com/cart/51642472431903:1';
          }} data-id="element-125">
              Get Instant Access
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-126" />
            </Button>

            <div className="flex items-center justify-center text-sm text-charcoal-600 gap-2" data-id="element-127">
              <ShieldCheck className="w-4 h-4 text-teal-700" data-id="element-128" />
              <span data-id="element-129">Secure payment</span>
            </div>
          </div>

          <div className="pt-8 border-t border-cream-200" data-id="element-130">
            <p className="text-sm text-charcoal-500 leading-relaxed max-w-lg mx-auto" data-id="element-131">
              You'll receive The Peri-Belly Protocol (PDF), plus all checklists
              and trackers immediately via email.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}